/**
 * CHECKVALID
 * 
 * Проверяет соответствие значения строки заданным параметрам.
 * В случае соответствия возвращает true, несоответствия - false
 * 
 * @param {String} input    - проверяемая строка
 * @param {String} mode     - тип проверки
 */
export default function checkValid(input, mode = false) {

    if(mode) {

        switch(mode) {

            case 'login': 
                if( input.length > 3)
                    return true
            break

            // 
            // 8     - Минимальная длинна пароля
            // 10    - Кол-во символов для надёжного пароля
            // 256   - Максимальная длинна пароля
            // true  - Минимум одна строчная и одна заглавная литинские буквы
            // true  - Минимум одна цифра
            // true  - Минимум один символ
            // 
            // Требования к паролю связаны с компонентом проверки паролей UTAPassIndicator.vue
            //
            case 'pass': 

                // Длина пароля - от 8 до 255 символов
                if(input.length < 8 || input.length > 255) {
                    return false
                }

                // Минимум одна строчная и одна заглавная буква
                if(!/^.*(?=.[a-z])(?=.*[A-Z]).*$/.test(input)) {
                    return false
                }

                // Минимум одна цифра
                if(!/[0-9]{1,}/.test(input)) {
                    return false
                }

                // Минимум один символ _ \ - % &
                if(/[_\-%&]/.test(input)) {
                    return true
                }

            break

            case 'email': 
                if(input.length > 5 && /^[\w-\.]+@[\w-]+\.[\w]{2,10}$/i.test(input) ) // eslint-disable-line
                    return true
            break

            case 'phone': 
                if(/^\+?[0-9)(\-\s]{2,30}[0-9]{1}$/g.test(input)) 
                    return true
            break

            case 'vin':
                if( /^[A-Za-z0-9]{17}$/i.test(input) ) 
                    return true
            break

            case 'imei':
                if( /^[0-9]{15}$/i.test(input) )
                    return true
            break

            case 'tid':
                if( /^[0-9]{3}$/i.test(input) )
                    return true
            break
        }

        return false

    } else {
        
        return true
    }
}